/*
 * fmh-gallery-nav.js
 * Pfeil-Buttons (Desktop) zum Durchblättern der Produktbilder.
 * Die Pfeile klicken intern den vorherigen/nächsten Thumbnail-Button
 * (nutzt die vorhandene Dawn-Mechanik) und werden per JS exakt an der
 * Bounding-Box des aktuell sichtbaren großen Bildes ausgerichtet – so
 * stehen sie nie über den Bildrand hinaus.
 */
(function () {
  var INSET = 10; // px, wie weit die Pfeile im Bild sitzen

  function thumbItems(gallery) {
    return Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item'));
  }

  function activeIndex(items) {
    for (var i = 0; i < items.length; i++) {
      var b = items[i].querySelector('button');
      if (b && b.getAttribute('aria-current') === 'true') return i;
    }
    for (var j = 0; j < items.length; j++) {
      if (items[j].classList.contains('is-active')) return j;
    }
    return 0;
  }

  function step(gallery, dir) {
    var items = thumbItems(gallery);
    if (items.length < 2) return;
    var cur = activeIndex(items);
    var n = dir === 'next'
      ? (cur + 1) % items.length
      : (cur - 1 + items.length) % items.length;
    var btn = items[n] && items[n].querySelector('button');
    if (btn) btn.click();
  }

  function makeButton(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fmh-media-nav fmh-media-nav--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Vorheriges Bild' : 'Nächstes Bild');
    b.innerHTML =
      '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">' +
      '<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="' +
      (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') +
      '"/></svg>';
    return b;
  }

  function activeImage(host) {
    var item = host.querySelector('.product__media-item.is-active') ||
               host.querySelector('.product__media-item');
    if (!item) return null;
    return item.querySelector('img, model-viewer, iframe, video') || item;
  }

  function place(host, prev, next) {
    var img = activeImage(host);
    if (!img) return;
    var hr = host.getBoundingClientRect();
    var ir = img.getBoundingClientRect();
    if (!ir.width || !ir.height) return;
    var top = (ir.top - hr.top) + ir.height / 2;
    prev.style.top = top + 'px';
    next.style.top = top + 'px';
    prev.style.left = Math.max(0, ir.left - hr.left + INSET) + 'px';
    next.style.right = Math.max(0, hr.right - ir.right + INSET) + 'px';
  }

  function init(gallery) {
    if (gallery.dataset.fmhNav === '1') return;
    if (thumbItems(gallery).length < 2) return;

    var mediaList = gallery.querySelector('.product__media-list');
    var host = (mediaList && mediaList.closest('slider-component')) || mediaList;
    if (!host) return;

    gallery.dataset.fmhNav = '1';
    host.classList.add('fmh-media-nav-host');

    var prev = makeButton('prev');
    var next = makeButton('next');
    var reposition = function () { place(host, prev, next); };

    prev.addEventListener('click', function () { step(gallery, 'prev'); setTimeout(reposition, 60); });
    next.addEventListener('click', function () { step(gallery, 'next'); setTimeout(reposition, 60); });
    host.appendChild(prev);
    host.appendChild(next);

    reposition();
    window.addEventListener('resize', reposition);
    window.addEventListener('load', reposition);
    var imgs = host.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) imgs[i].addEventListener('load', reposition, { once: true });
    }
    if (mediaList) {
      var mo = new MutationObserver(function () { setTimeout(reposition, 30); });
      mo.observe(mediaList, { attributes: true, subtree: true, attributeFilter: ['class'] });
    }
  }

  function boot() {
    document.querySelectorAll('media-gallery').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
